import { useStore } from "zustand";
import ButtonIcon from "../ButtonIcon";
import { useDashboardName } from "../../store/headerName";
import ButtonIconSvg from "../ButtonIconSvg";
import Magnifier from "../svg/Magnifier";
import Bell from "../svg/Bell";
import Setting from "../svg/Setting";
import User from "../svg/User";
import { Button, Dropdown, Modal } from "antd";
import { useState } from "react";
import Cookies from "js-cookie";
import { useNotify } from "../../helper/notify";
import { useLocation, useNavigate } from "react-router";
import type { components } from "../../helper";
import { logoutMethod } from "../../helper/method";
import { promisePipe } from "../../helper/exception-handler";

export default function Header() {
  const { dashboardName } = useStore(useDashboardName);
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [sending, setSending] = useState(false);
  const pathname = useLocation();
  const navigate = useNavigate();

  const logout = async () => {
    if (sending) return;
    setSending(true);
    promisePipe(
      logoutMethod(Cookies.get("token") ?? "")
        .then((res: components["schemas"]["BaseModel"]) => {
          Cookies.remove("token", {
            path: "/",
            domain: ".modirino.com",
          });
          notify.success(res.message);
          setSending(false);
          setIsOpen(false);
          setTimeout(() => {
            navigate(
              `https://rashed-demo-student.modirino.com/login?callback=${pathname.pathname}`,
            );
          }, 3000);
        })
        .catch((error) => {
          notify.error(error.toString());
          console.log("error");
          setSending(false);
        }),
    );
  };
  return (
    <header className="py-6 print:hidden lg:px-10 px-5 z-10 sticky top-0 flex justify-between left-0 bg-white/60 backdrop-blur-sm w-full">
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        classNames={{
          footer: "hidden!",
        }}
        closeIcon={false}
        title={<span className="text-20-semi-bold">خروج از حساب کاربری</span>}
      >
        <div className="flex flex-col gap-4">
          <p className="text-16-regular">
            آیا مطمعن هستید که میخواهید از حساب کاربری خود خارج شوید؟
          </p>
          <div className="flex w-full gap-4">
            <Button
              onClick={() => setIsOpen(false)}
              danger
              type="primary"
              className="w-1/2"
            >
              لغو
            </Button>
            <Button
              loading={sending}
              onClick={logout}
              type="primary"
              className="w-1/2"
            >
              تایید
            </Button>
          </div>
        </div>
      </Modal>
      <ButtonIcon
        icon="solar:hamburger-menu-line-duotone"
        className="lg:hidden flex items-center text-grayscale-950 bg-grayscale-200 gap-2"
      />
      <h1 className="display-24-bold lg:flex hidden">{dashboardName}</h1>
      <div className="flex items-center gap-2">
        <ButtonIconSvg icon={<Magnifier />} />
        <ButtonIconSvg icon={<Bell />} />
        <ButtonIconSvg icon={<Setting />} spin />
        <Dropdown
          arrow
          trigger={["click"]}
          menu={{
            items: [
              {
                key: "1",
                label: "خروج از حساب کاربری",
                className: "text-red-500!",
                onClick: () => {
                  setIsOpen(true);
                },
              },
            ],
          }}
        >
          <ButtonIconSvg icon={<User />} />
        </Dropdown>
        {/* <ButtonIcon icon="solar:minimalistic-magnifer-bold-duotone" />
        <ButtonIcon icon="solar:bell-bold-duotone" />
        <ButtonIcon spin icon="solar:settings-bold-duotone" />
        <ButtonIcon icon="solar:users-group-rounded-bold-duotone" /> */}
        {/* <div className="rounded-full w-10 h-10 outline-grayscale-500 outline-1 outline-offset-2 overflow-hidden">
          <img
            className="w-full h-full"
            src="/image/avatar-25.webp"
            alt="user-profile"
          />
        </div> */}
      </div>
    </header>
  );
}
